module.exports = __webpack_public_path__ + "media/public/images/about/services/03-3ae4983c2694ff5c83f4b5bdffd64167.jpg";